














































import { Component, Vue, Provide } from "vue-property-decorator";
import { pagnition } from "@/utils/commonConfig";

@Component({
  name: "CombinationProperty"
  
})
export default class CombinationProperty extends Vue {
    @Provide() private userCode: string = '';
    @Provide() private staffInfo: any = [
            {
            staffName: '王小虎',
            staffNumber:103123221,
            staffSpartment:'Uger_TL_01',
            staffRole:'Uger_om',
            staffStatus: '在职'
            }, {
            staffName: '王二虎',
            staffNumber:103123221,
            staffSpartment:'Uger_TL_01',
            staffRole:'Uger_om',
            staffStatus: '在职'
            }, {
            staffName: '王三',
            staffNumber:103123221,
            staffSpartment:'Uger_TL_01',
            staffRole:'Uger_om',
            staffStatus: '离职'
            }
    ];


    @Provide() private pagnition: any = pagnition;
    @Provide() private pageIndex: number = 1;
    @Provide() private pageSize: number = 20;
    @Provide() private pagerCount: number = 0;

    private infoSearch () {
    }

    private handleSizeChange (size:any) {
        this.pageSize = Number(size);
        this.searchPeopleInfo();
    }

    private handleCurrentChange (index:any) {
        this.pageIndex = Number(index);
        this.searchPeopleInfo();
    }
    // 上一页
    private handlePrevChange () {
        if (this.pageIndex > 0) {
            this.searchPeopleInfo();
        }
    }
    // 下一页
    private handleNextChange () {
        this.searchPeopleInfo();
    }
    //获取列表数据
    private searchPeopleInfo() {

    }

    //点击 查看按钮
    private lookPeopleInfo(row:any) {
        this.$router.push({path:'/peopleInfoDetail'})
    }

    // 点击 添加按钮
    private addPeopleInfo() {
        this.$router.push({path:'/addPeopleInfo'})
    }


}
